import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
} from 'libs/form';

export const LENGTH_LEI = 20;
export const LENGTH_GIIN = 19;

export interface IdentificationNumbersFormType {
  identificationNumbers: {
    LEI?: string | null;
    GIIN?: string | null;
  };
}
export const getIdentificationNumbersSchema =
  (): ObjectSchema<IdentificationNumbersFormType> =>
    object({
      identificationNumbers: object({
        LEI: string().nullable().length(LENGTH_LEI),
        GIIN: string().nullable().length(LENGTH_GIIN),
      }),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<IdentificationNumbersFormType>();

export type FormErrors = FormErrorsBase<IdentificationNumbersFormType>;
